export default "__VITE_ASSET__Is1ipq0c__"